// extracted by mini-css-extract-plugin
export var cardHeader = "_i3-0";
export var reorderHandle = "_i3-3";
export var titleArea = "_i3-1";
export var titleAreaWithHandle = "_i3-2";